if (!customElements.get('du-video')) {
  customElements.define('du-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('button')?.addEventListener('click', () => {
        const id = this.dataset.videoId;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        frame.title = this.dataset.videoTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      }, {once:true});
    }
  });
}
